import Icon from 'veui/components/Icon'
import { IconDesktop } from 'dls-icons-vue'

Icon.register('desktop', IconDesktop)
